import { ofType } from "redux-observable";
import { of } from "rxjs";
import { guard } from "../../guards/guard";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionWaterTowerCollectWater, TypeActionWaterTower } from "../actionWaterTower";
import { checkIsWaterReadyForCollection } from "../checks/checkIsWaterReadyForCollection";
export var epicWaterTowerSelect = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionWaterTower.Select), guard(state$, deps, function () { return of(actionModalOpen(IdModal.WaterTower)); })([
        checkIsWaterReadyForCollection(function () { return of(actionWaterTowerCollectWater()); }),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/epics/epicWaterTowerSelect.ts
// module id = 2509
// module chunks = 3